import { pathJoin } from 'src/reducers/routing/utils'

export const createDetailRoutesMap = (prefix: string) => ({
  overview: pathJoin(prefix)('overview').chain,
  properties: pathJoin(prefix)('properties').chain,
  tickets: pathJoin(prefix)('tickets').chain,
  // 3.1.38 / PRODUCT-178: scheduled customer-data changes as a first-class
  // tab on the legacy contact view too (same relocation as the standalone
  // contact detail — the always-rendered block above the tab strip broke
  // the page's scroll math, PRODUCT-177).
  'scheduled-changes': pathJoin(prefix)('scheduled-changes').chain,
})
